import React, { useRef, useState } from 'react';

import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField';

const QualificationInput = ({ index, item: {course, institution, year}, onChange, onDelete, classes }) => {
    const [activeRow, setActiveRow] = useState(-1);
    const courseRef = useRef();
    const institutionRef = useRef();
    const yearRef = useRef();

    return (
        <div onMouseEnter={() => setActiveRow(index)} onMouseLeave={() => setActiveRow(-1)}>
            <TextField
                label="Course"
                placeholder='eg BSc (Hons) Speech & Language Therapy'
                defaultValue={course}
                inputRef={courseRef}
                onChange={() => onChange(index, { course: courseRef.current.value })}
                className={classes.field}
                style={{ minWidth: '40%' }}
                variant="outlined"
            />
            <TextField
                label="College / Institution"
                placeholder='eg University of Life'
                defaultValue={institution}
                inputRef={institutionRef}
                onChange={() => onChange(index, { institution: institutionRef.current.value })}
                className={classes.field}
                style={{ minWidth: '30%' }}
                variant="outlined"
            />
            <TextField
                label="Year"
                defaultValue={year}
                inputRef={yearRef}
                onChange={() => onChange(index, { year: yearRef.current.value })}
                className={classes.field}
                style={{ minWidth: '10%' }}
                variant="outlined"
            />
            {
                activeRow === index ? 
                    <Button 
                        variant="outlined"
                        onClick={() => onDelete(index)}
                        aria-label="delete" 
                        color="secondary" 
                        style={{marginTop: '0.5rem'}}>DELETE
                    </Button>
                    : <></>
            }
        </div>
    )
}

export default QualificationInput;